import React, { useEffect, useState } from 'react';
import { getProfile } from '../../../services/UserService';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../../components/PageHeader/PageHeader';
import PersonalInfoCard from './PersonalInfoCard';
import ProfessionalInfoCard from './ProfessionalInfoCard';
import SettingsCard from './SettingsCard';
import EditPersonalInfoModal from './EditPersonalInfoModal';
import { Grid, Box } from '@mui/material';

const ProfilePage = () => {
    const { t } = useTranslation();
    const [user, setUser] = useState(null);
    const [error, setError] = useState(null);
    const [isEditModalOpen, setEditModalOpen] = useState(false);

    useEffect(() => {
        const fetchUserProfile = async () => {
            try {
                const userData = await getProfile();
                setUser(userData);
            } catch (error) {
                setError('An error occurred while fetching the user profile.');
            }
        };

        fetchUserProfile();
    }, []);

    const handleSave = (updatedUser) => {
        setUser(updatedUser);
    };

    return (
        <Box p={3}>
            <PageHeader title={t('profile')} subtitle={t('profile_header')} />
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} lg={4}>
                    {user ? <PersonalInfoCard user={user} onEdit={() => setEditModalOpen(true)} /> : <div>Loading...</div>}
                </Grid>
                <Grid item xs={12} sm={6} lg={4}>
                    <ProfessionalInfoCard user={user}/>
                </Grid>
                <Grid item xs={12} sm={6} lg={4}>
                    <SettingsCard />
                </Grid>
            </Grid>
            {user && (
                <EditPersonalInfoModal
                    open={isEditModalOpen}
                    onClose={() => setEditModalOpen(false)}
                    user={user}
                    onSave={handleSave}
                />
            )}
        </Box>
    );
};

export default React.memo(ProfilePage);
